//chapter1
export default {
    id : 6,//chapter number
    title : '06. FMEA 5판 (1) - FMEA 5판과 주요 변경내용',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c06.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'FMEA 5판의 구성',
                'FMEA 주요 변경내용',
            ],
            body2 : [
                'FMEA 5판의 구성에 대해 설명할 수 있다.',
                'FMEA 주요 변경내용에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '06.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : 'FMEA 5판은 AIAG에서 개발되었다.',//html available
                    answer : "2",
                    explain : 'VDA와 AIAG에 의해 개발되었다.'
                },
                {
                    type : 'ox',
                    question : 'FMEA 전개단계는 이전과 5판이 동일하다.',//html available
                    answer : "2",
                    explain : '새로운 7STEP이 적용되었다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. FMEA 5판과 주요 변경내용</h3>
                        <li>5판의 기본구조</li>
                        <p class="mg10"></p>
                        <h3>2. FMEA 5판의 개요</h3>
                        <li>RISK 평가 방법의 변경</li>
                        <li>적용 Timing의 APQP 단계와 연계</li>
                        <li>설계 FMEA와 공정 FMEA의 연계</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c06.mp4',
        },
    ]
}